export enum Client {
    Default = 'default',
    Web = 'web',
    iOS = 'ios',
    Android = 'android',
    CinemaWebsite = 'cinema_website'
}
